import React from 'react';
import { InformationCircleIcon } from './Icons';

/**
 * Icon "i" nhỏ kèm hộp giải thích khi hover — dùng cho các thao tác/khái niệm
 * dễ gây do dự (GV không chắc bấm vào sẽ ảnh hưởng gì). Theo đúng phong cách
 * tooltip hover đã dùng ở AddMultipleStudentsModal (bg-slate-800, fade opacity).
 */
export const InfoTooltip: React.FC<{
    text: string;
    className?: string;
    /** Vị trí hộp giải thích so với icon — mặc định phía trên, căn giữa. */
    align?: 'center' | 'left' | 'right';
}> = ({ text, className = '', align = 'center' }) => {
    const alignClass = align === 'left' ? 'left-0' : align === 'right' ? 'right-0' : 'left-1/2 -translate-x-1/2';
    return (
        <span className={`relative inline-flex group/infotip ${className}`}>
            <InformationCircleIcon className="h-3.5 w-3.5 text-slate-300 hover:text-slate-500 cursor-help transition-colors shrink-0" />
            <span
                className={`absolute z-30 bottom-full ${alignClass} mb-2 w-56 p-2.5 bg-slate-800 text-white text-[10px] leading-relaxed font-medium normal-case tracking-normal rounded-lg opacity-0 group-hover/infotip:opacity-100 pointer-events-none transition-opacity shadow-xl text-left whitespace-pre-line`}
            >
                {text}
            </span>
        </span>
    );
};

export default InfoTooltip;
